

export function getBasePathFromWidgetSource(): { path: string, key?: string } {
    const xappScriptNode = document?.getElementById("xapp-form-js") as HTMLScriptElement | undefined;
    const path = getBasePath(xappScriptNode?.src);
    return path;
}

// https://dev-widget.xapp.media/xapp-form-widget.js?key=f3af5f1f-cfc1-4ca7-a1e9-a411288d5190

export function getBasePath(path?: string): { path: string, key?: string } {
    if (!path) {
        return { path: "" };
    }
    const lastPathSep = path.lastIndexOf("/");
    let result = "";
    if (lastPathSep >= 0) {
        result = path.substr(0, lastPathSep);
    }

    const url = new URL(path);
    const params = new URLSearchParams(url.search);
    const key = params.get("key") || "";

    return { path: result, key };
}